import React from "react"
import styled, { css } from "styled-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IconDefinition } from "@fortawesome/fontawesome-svg-core"

import Card from "./Card"
import OverviewSimple from "./OverviewSimple"

type StyledHeaderProps = {
  readonly standalone: boolean;
}

const StyledTag = styled(Card)<StyledHeaderProps>`
  background-color: var(--white);

  ${props => props.standalone && css`
    margin-top: 5px;
    margin-bottom: 5px;
    border-radius: 5px;
    box-shadow: var(--shadow-elavated);
  `}
`

const Icon = styled(FontAwesomeIcon)`
`

type Props = {
  name: string
  icon: IconDefinition
  iconcolor: string
  proficiency?: string
  standalone?: boolean
}

const SkillTag = ({name, icon, iconcolor, proficiency="", standalone=false}: Props) =>
  <StyledTag standalone={standalone}>
    <OverviewSimple
      graphic={<Icon icon={icon} color={iconcolor}/>}
      maintext={name}
      subtext={proficiency}
    />
  </StyledTag>

export default SkillTag
